import ConfirmationDialog from '../../../../../common/components/ConfirmationDialog/ConfirmationDialog';
import { Submission } from './submission-graphql';
import { generateSubmissionPortalPreviewRoute } from '../QATool/helpers/preview-helpers';
import { getLatestBuild } from '../../../../../common/build-utils';

interface Props {
  submission: Submission;
  opened: boolean;
  onClose: () => void;
}

const BackToPreviewConfirmationPopup: React.FC<Props> = ({ opened, onClose, submission }: Props) => {
  const goToPreview = () => {
    const latestBuild = getLatestBuild(submission.gameBuilds);
    const url = generateSubmissionPortalPreviewRoute(submission.id, {
      gameBuildId: latestBuild.id,
      qaTool: true,
      disableSubmitQA: true,
    });
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  if (!opened) {
    return null;
  }

  return (
    <ConfirmationDialog
      title="Return to preview?"
      onClose={(res) => {
        if (res === 'confirmed') {
          goToPreview();
        }
        onClose();
      }}
      cancelable
      okButtonText="Continue to preview"
    >
      <>You can preview the game again but you can't modify the QA results. Upload a new version if you want to pass QA again.</>
    </ConfirmationDialog>
  );
};

export default BackToPreviewConfirmationPopup;
